<p-overlayPanel [style]="{color: 'red'}" #erroroverlay>
   <div *ngFor="let error of this.inputErrors">
      {{error}}
   </div>
</p-overlayPanel>

<p-overlayPanel #hoveroverlay [appendTo]="'body'" [baseZIndex]="100"
   [style]="{'max-width': '275px','margin-left': '-50px','word-break':'break-word'}">
   <div *ngFor="let info of this.hoverInfo">
      <b>{{info.title}}: </b> <span class="text-break">{{info.data}}</span>
   </div>
</p-overlayPanel>

<div class="table-wrapper">
   <p-table #table [value]="data" [columns]="columns" [scrollable]="true" scrollHeight="flex" [(selection)]="selections"
      [metaKeySelection]="true" [selectionMode]="multiselect ? '' : 'multiple'" (onRowSelect)="onSelect($event)"
      (onEditInit)="onEditClick.emit($event)" (onEditComplete)="onEditSave.emit($event)"
      (onRowUnselect)="onUnselect($event)" [sortField]="sortField" (onSort)="onSort($event)" [paginator]="paged"
      [rows]="pageSize" [rowsPerPageOptions]="ROWCOUNT_OPTIONS" [currentPageReportTemplate]="PAGE_REPORT"
      [showCurrentPageReport]="showCurrentPageReport" (onLazyLoad)="onLazyLoad($event)" (onPage)="onPageChange($event)"
      [lazy]="lazy" [lazyLoadOnInit]="lazyLoadOnInit" [loading]="loading" [totalRecords]="totalRecords"
      paginatorDropdownAppendTo="body" compareSelectionBy="equals" [class]="isEmpty ? 'h-scrollable' : ''"
      [resizableColumns]="true" columnResizeMode="expand" [rowTrackBy]="trackBy(trackByField)">

      <ng-template pTemplate="caption">
         <div #titlebar class="h5 m-0 d-flex align-items-center justify-content-center"
            [class.header-footer-min-row-height]="!!titlebar.innerHTML.trim()">
            <ng-content select="[title]"></ng-content>
         </div>
         <mat-divider *ngIf="!!titlebar.innerHTML.trim()" class="my-1"></mat-divider>
         <div class="action-buttons header-footer-min-row-height ">
            <span class="start">
               <p-multiSelect *ngIf="filterColumnDisplay" [options]="displayableColumns" [(ngModel)]="displayedColumns"
                  optionLabel="name" [selectedItemsLabel]="FILTER_COLUMN_DISPLAY_NAME"
                  [defaultLabel]="FILTER_COLUMN_DISPLAY_NAME" [maxSelectedLabels]="0">
               </p-multiSelect>
               <ng-content select="[actionStart]"></ng-content>
            </span>
            <span class="end">
               <ng-content select="[actionEnd]"></ng-content>
               <button mat-icon-button [disableRipple]="true"
                  *ngIf="filterable && !filterDisplayed; else filterBtnClicked" (click)="toggleFilterDisplay()">
                  <mat-icon matTooltip="Filters">filter_list</mat-icon>
               </button>
               <ng-template #filterBtnClicked>
                  <button [class.mat-elevation-z0]="true" mat-mini-fab color="primary" [disableRipple]="true"
                     *ngIf="filterable && filterDisplayed" (click)="toggleFilterDisplay()">
                     <mat-icon>filter_list</mat-icon>
                  </button>
               </ng-template>
            </span>
         </div>
      </ng-template>

      <!-- 
        This colgroup is used to handle the display of each of the column.
        We do this because that's how primeng handles overall column styling.
   -->
      <ng-template pTemplate="colgroup">
         <colgroup>
            <!-- Column styling for multi-select checkboxes -->
            <col *ngIf="multiselect" [ngStyle]="{width: '3.2em'}" />
            <!-- Column styling for number label-->
            <col *ngIf="showNumberColumn" [ngStyle]="{width: '3.4em'}" />
            <ng-container *ngFor="let col of columns">
               <col *ngIf="isColumnDisplayed(col.field)" [ngStyle]="{width: (col.width != 0 ? col.width : '12em')}" />
            </ng-container>
         </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
         <tr>
            <!-- Header for multi-select column -->
            <th *ngIf="multiselect" id="multi-select-checkboxes">
               <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <!-- Header for number label -->
            <th scope="col" *ngIf="showNumberColumn">No</th>
            <ng-container *ngFor="let col of columns">
               <ng-container [ngSwitch]="col.type || ''">
                  <!-- 
                    The switch case allows us to create different components 
                    per different type of header display. Otherwise, default display 
                    of a header is string.
               -->
                  <ng-container *ngSwitchDefault>
                     <th #header *ngIf="isColumnDisplayed(col.field)" class="text-center"
                        [class.overflow]="header?.clientWidth < header?.scrollWidth"
                        [class.readonly]="!col.editable && col.headerHighlight"
                        [pSortableColumnDisabled]="col.sortingDisabled" [pSortableColumn]="col.field" scope="col"
                        pResizableColumn
                        [matTooltip]="getTooltipOverflowText(col.name,header) + (getTooltipText(col.tooltip) || col.name)"
                        [matTooltipClass]="'tooltip-linebreak'"
                        [matTooltipDisabled]="!col.tooltip && !header?.classList.contains('overflow')"
                        matTooltipPosition="below">
                        {{col.name}}
                        <ng-container *ngIf="isSorted(col.field)">
                           <p-sortIcon [field]="col.field"></p-sortIcon>
                        </ng-container>
                     </th>
                  </ng-container>

               </ng-container>
            </ng-container>
         </tr>

         <!-- 
           We use css to hide the filters instead of ngIf so the input values
           don't disappear when toggling the filter display.
      -->
         <tr [ngStyle]="filterDisplayed ? {} : {'display': 'none'}" class="column-filters">
            <th scope="col" *ngIf="multiselect"></th>
            <th scope="col" *ngIf="showNumberColumn"></th>
            <ng-container *ngFor="let col of columns">
               <th scope="col" *ngIf="isColumnDisplayed(col.field)">
                  <input *ngIf="col.filterField" #field pInputText class="filter" type="text"
                     (input)="table.filter(field.value, col.field, 'startsWith')" />
               </th>
            </ng-container>
         </tr>

         <!--
         Used to display an empty table when there is no data populated.
      -->
         <tr *ngIf="isEmpty">
            <th scope="colgroup" [attr.colspan]="displayedColumnLength"> No data found.</th>
         </tr>
      </ng-template>

      <ng-template pTemplate="body" let-dataItem let-columns="columns" let-rowIndex="rowIndex">
         <tr [pSelectableRow]="selected !== dataItem ? dataItem : {}" [pSelectableRowIndex]="rowIndex"
            [pSelectableRowDisabled]="!canSelectRow(dataItem)">
            <td *ngIf="multiselect">
               <p-tableCheckbox [value]="dataItem" [disabled]="!canSelectRow(dataItem)"></p-tableCheckbox>
            </td>
            <td *ngIf="showNumberColumn">{{rowIndex + 1}}</td>
            <ng-container *ngFor="let col of columns">
               <ng-container *ngIf="isColumnDisplayed(col.field)">
                  <ng-container [ngSwitch]="col.type || ''">
                     <!-- 
                    The switch case allows us to create different components 
                    per different type of cell display. Otherwise, default display 
                    of a cell is string.
               -->
                     <ng-container *ngSwitchCase="'checkbox'">
                        <td class="centered-text">
                           <mat-checkbox type="checkbox" [disabled]="!col.editable || !col.cellEditable(col,dataItem)"
                              [checked]="dataItem[col.field]" [(ngModel)]="dataItem[col.field]" color="primary"
                              (change)="onEdit(dataItem, col.field, rowIndex)">
                           </mat-checkbox>
                        </td>
                     </ng-container>

                     <ng-container *ngSwitchCase="'date'">
                        <td *ngIf="col.editable; else dateReadOnly">
                           <div class="date-field d-flex flex-nowrap">
                              <input matInput [matDatepicker]="picker" [(ngModel)]="dataItem[col.field]"
                                 [disabled]="!col.cellEditable(col,dataItem)"
                                 (dateChange)="onEdit(dataItem, col.field, rowIndex)" />
                              <i (click)="picker.open()" class="hover-visible fa fa-calendar "></i>
                              <mat-datepicker #picker></mat-datepicker>
                           </div>
                        </td>
                        <ng-template #dateReadOnly>
                           <td [class.readonly]="!col.editable && col.headerHighlight">
                              {{ cleanDate(dataItem[col.field]) }} </td>
                        </ng-template>
                     </ng-container>


                     <ng-container *ngSwitchCase="'dropdown'">
                        <td pEditableColumn>
                           <p-cellEditor>
                              <ng-template pTemplate="input">
                                 <mat-select [(ngModel)]="dataItem[col.field]"
                                    (selectionChange)="onEdit(dataItem, col.field, rowIndex)"
                                    [placeholder]="dataItem[col.placeHolderField]"
                                    [disabled]="!col.editable || !col.cellEditable(col,dataItem)">
                                    <mat-option *ngIf="col.isEmptySelection" (click)="clearSelection()"></mat-option>
                                    <mat-option *ngFor=" let opt of optionsList(col.optionsList) | async"
                                       (mouseenter)="handleHoverEnter($event,opt,col.cellHoverInfo)"
                                       (mouseleave)="handleHoverLeave($event)" [value]="opt[col.optionsListField]">
                                       {{ opt[col.optionsListName] }}
                                    </mat-option>
                                 </mat-select>
                              </ng-template>
                              <ng-template pTemplate="output">
                                 <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                    [class.readonly]="!col.editable && col.headerHighlight"
                                    *ngIf="getDropdownValue(dataItem[col.field],col.optionsListField,col.optionsListName,(optionsList(col.optionsList) | async),dataItem[col.placeHolderField]) as text"
                                    (mouseenter)="handleTooltipEnter($event,text)"
                                    (mouseleave)="handleTooltipLeave($event)">
                                    {{text}}
                                 </div>
                              </ng-template>
                           </p-cellEditor>
                        </td>
                     </ng-container>

                     <ng-container *ngSwitchCase="'icon-button'">
                        <td class="centered-text">
                           <button [disabled]="!col.editable || !col.cellEditable(col,dataItem)" mat-icon-button
                              (keypress.enter)="col.callback(dataItem)" (click)="col.callback(dataItem)">
                              <mat-icon>{{col.icon}}</mat-icon>
                           </button>
                        </td>
                     </ng-container>

                     <ng-container *ngSwitchCase="'link'">
                        <td>
                           <span id="link-cell" (click)="col.callback(dataItem)">{{dataItem[col.field]}}</span>
                        </td>
                     </ng-container>

                     <ng-container *ngSwitchCase="'truncate'">
                        <td class="td-truncate" *ngIf="col.editable && col.cellEditable(col,dataItem); else notEditable"
                           [pEditableColumn]="dataItem" [pEditableColumnField]="col.field"
                           [pEditableColumnField]="rowIndex">
                           <p-cellEditor>
                              <ng-template pTemplate="input">
                                 <input pInputText type="text" [(ngModel)]="dataItem[col.field]"
                                    (blur)="onEdit(dataItem, col.field, rowIndex)"
                                    (focus)="onFocusInput({input: $event?.srcElement, rowIndex: rowIndex, data: dataItem[col.field]})"
                                    (keydown.enter)="onEdit(dataItem, col.field, rowIndex)" />
                              </ng-template>
                              <ng-template pTemplate="output">
                                 {{dataItem[col.field]}}
                              </ng-template>
                           </p-cellEditor>
                        </td>

                        <ng-template #notEditable>
                           <td class="td-truncate" [pEditableColumn]="dataItem" [pEditableColumnField]="col.field"
                              [pEditableColumnField]="rowIndex">
                              <p-cellEditor>
                                 <ng-template pTemplate="input">
                                    <input readonly pInputText type="text" [ngModel]="dataItem[col.field]" />
                                 </ng-template>
                                 <ng-template pTemplate="output">
                                    {{dataItem[col.field]}}
                                 </ng-template>
                              </p-cellEditor>
                           </td>
                        </ng-template>
                     </ng-container>

                     <!-- Searchable Text -->
                     <ng-container *ngSwitchCase="'searchable-text'">
                        <td class="td-truncate" [pEditableColumn]="dataItem" [pEditableColumnField]="col.field"
                           [pEditableColumnField]="rowIndex">
                           <p-cellEditor>
                              <ng-template pTemplate="input">
                                 <searchable-autocomplete [options]="optionsList(col.optionsList,col) | async"
                                    [filterBy]="col.optionsListField" [display]="col.optionsListName"
                                    [(selected)]="dataItem[col.field]" (select)="onEdit(dataItem,col.field,rowIndex)"
                                    [disabled]="!col.editable || !col.cellEditable(col,dataItem)" [exactMatch]="false"
                                    [value]="col.optionsListField">
                                 </searchable-autocomplete>
                              </ng-template>
                              <ng-template pTemplate="output">
                                 {{dataItem[col.field]}}
                              </ng-template>
                           </p-cellEditor>
                        </td>
                     </ng-container>

                     <!-- Readonly Case -->
                     <ng-container *ngSwitchCase="'readonly'">
                        <td *ngIf="col.editable && col.cellEditable(col,dataItem); else notEditable"
                           (mouseenter)="handleTooltipEnter($event,dataItem[col.field])"
                           (mouseleave)="handleTooltipLeave($event)">
                           <p-cellEditor>
                              <ng-template pTemplate="input">
                                 <input pInputText type="text" />
                              </ng-template>
                              <ng-template pTemplate="output">
                                 {{dataItem[col.field]}}
                              </ng-template>
                           </p-cellEditor>
                        </td>
                        <ng-template #notEditable>
                           <td (mouseenter)="handleTooltipEnter($event,dataItem[col.field])"
                              (mouseleave)="handleTooltipLeave($event)">
                              {{dataItem[col.field]}} </td>
                        </ng-template>
                     </ng-container>


                     <!-- Default Case -->
                     <ng-container *ngSwitchDefault>
                        <td #defaultTableData *ngIf="col.editable && col.cellEditable(col,dataItem); else notEditable"
                           [pEditableColumn]="dataItem" [pEditableColumnField]="col.field"
                           [pEditableColumnField]="rowIndex"
                           (mouseenter)="handleTooltipEnter($event,dataItem[col.field])"
                           (mouseleave)="handleTooltipLeave($event)">
                           <p-cellEditor>
                              <ng-template pTemplate="input">
                                 <textarea pInputText type="text" [(ngModel)]="dataItem[col.field]"
                                    (blur)="onEdit(dataItem, col.field, rowIndex)"
                                    (focus)="onFocusInput({input: $event?.srcElement, rowIndex: rowIndex, data: dataItem[col.field]})"
                                    (input)="validateFieldInput($event,col)"
                                    (keydown.enter)="onEdit(dataItem, col.field, rowIndex)"
                                    [class.readonly]="!col.editable && col.headerHighlight">
                                 </textarea>
                              </ng-template>
                              <ng-template pTemplate="output">
                                 <span [class.readonly]="!col.editable && col.headerHighlight">
                                    {{dataItem[col.field]}}
                                 </span>
                              </ng-template>
                           </p-cellEditor>
                        </td>

                        <ng-template #notEditable>
                           <td #defaultTableDataReadonly [class.readonly]="!col.editable && col.headerHighlight"
                              [ngClass]="{'grey': col.greyedOut}"
                              (mouseenter)="handleTooltipEnter($event,dataItem[col.field])"
                              (mouseleave)="handleTooltipLeave($event)">
                              {{dataItem[col.field]}} </td>
                        </ng-template>
                     </ng-container>

                  </ng-container>
               </ng-container>
            </ng-container>
         </tr>
      </ng-template>
   </p-table>
</div>
